export default "__VITE_ASSET__41f427ec__"